export class Sku{
    _id?: string;
    ref?: string;
    productName?: string;
    productDescription?: string;
    new?: boolean;
    inventoryLocation?: string;
    type?: string;
    forSale?: boolean;
    stockUnits?: number;
    storageUnitsBag?: number;
    storageUnitsBox?: number;
    category?: string;
    manufacturerRef?: string;
    supplier?: object;
    isInventoriable?: boolean;
    canBeRented?: boolean;
    dailyRentalPrice?: number;
    salePrice?: number;
    /**
     * MeteringEventType value consumed when this SKU is sold or rented.
     * Enables SKU-aware metering: different hardware maps to different billing metrics.
     */
    billingMetric?: string;
    createdAt?: Date;
    updatedAt?: Date;
  }